<template>
  <v-data-table
    :headers="headers"
    :items="cleanData"
    disable-pagination
    hide-default-footer
  >
    <template #item.name="{item}">
      <code>{{item.name}}</code>
    </template>
    <template #item.description="{item}">
      <markdown
        v-if="item.description"
        :source="item.description"
      />
    </template>
    <template #item.returns.type="{item}">
      <code>{{item.returns.type}}</code>
      <div>{{item.returns.description}}</div>
    </template>
    <template #item.params="{item}">
      <params-table
        v-if="item.params.length"
        :data="item.params"
      />
      <div v-else>
        No params
      </div>
    </template>

  </v-data-table>
</template>

<script>
import ParamsTable from '@/components/componentPreview/ParamsTable';
import Markdown from '@/components/Markdown';

export default {
  name: 'MethodsTable',
  components: {Markdown, ParamsTable},
  props: {
    data: Array,
  },
  data() {
    return {
      headers: [
        {text: 'Name', value: 'name'},
        {text: 'Description', value: 'description'},
        {text: 'Returns', value: 'returns.type'},
        {text: 'Params', value: 'params', sortable: false},
      ],
    };
  },
  computed: {
    cleanData() {
      return this.data.map((item) => {
        // The parser seems to not pull the type in, so let's extract it from keywords if set
        const type = item.keywords.find(({name}) => name === 'type')?.description || item.type;

        return {
          ...item,
          type,
        };
      })
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
